import Vue from "vue";
require("./default.js");

Object.assign(Vue.config, {
  ATLANTIS_URL: "http://localhost:8887",
  // EL_DORADO_API_URL: 'http://localhost:3000',
 EL_DORADO_API_URL: "https://api.kuvera.in",
// EL_DORADO_API_URL: "https://el-dorado.kuvera.in",
  ENV: "development",
  ASSET_PATH: process.env.ASSET_PATH,
  LOGOUT_TIMEOUT: 30000 * 60 * 1000
});

